import { fieldNames, SUB_FIELD_OTHER_VALUE } from '../constants/common';

const resetOtherSubReason = (setFieldValue, options) => {
  if (!options.includes(SUB_FIELD_OTHER_VALUE)) {
    setFieldValue(fieldNames.OTHER_SUB_REASON, null);
  }
};

export default resetOtherSubReason;
